export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-16.5307e8d7.png";